import { AUTH_URL } from "constants/routes";
import { apiRequest } from "api";
import requestV1 from "./encryptAuth";
import { useDispatch } from "react-redux";
import loggedInUserInfo from "redux/loggedInUserInfo";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDecryptedResponse } from "./decrypt";
import { BASE_URL } from "constants/routes";
import { encryptPayload } from "./encrypt";

// export const userAuth = createAsyncThunk("userAuth", async (data) => {
//   console.log("🚀 ~ userAuth ~ data:", data)
//    const userToken = JSON.parse(localStorage.getItem('userToken') || '{}');
//   const sessionToken = localStorage.getItem('sessionToken');
//   const req = `${AUTH_URL}/api/auth/getUserInfo`;
//   let options = {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: sessionToken|| data.loggedInUser.token,
//       "user-id": userToken.userId|| data?.loggedInUser?.userId
//     },
//     body: data,
//   };
//   console.log("🚀 ~ userAuth ~ options:", options)
//   try {
//     const response = await requestV1(req, options, true, false);
//     // console.log("before",response);
//     // response = await getDecryptedResponse(response)
//     // console.log("after",response);

//     return response.userInfo;
//   } catch (error) {
//     throw error;
//   }
// });

export const userAuth = createAsyncThunk("userAuth", async (data) => {
  const req = `${BASE_URL}/auth/getUserInfo`;
  
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: data.loggedInUser.token,
      refreshToken: data.loggedInUser.refreshToken,
    },
    body: data,
  };
  try {
    const requestForRandomId = `${BASE_URL}/auth/getRandomId`;
    let option_params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const resposeFromRandomId = await encryptPayload(requestForRandomId, option_params, false, false, false);

    const response = await requestV1(req, options, true, false, resposeFromRandomId?.data?.encryptToken);
    
    
    const options_v1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: typeof response === "string" ? response : JSON.stringify(response),
    };
     let finalResponse = await encryptPayload(req, options_v1, false, true, true);
    try {
      // let decryptedResponse = await getDecryptedResponse(finalResponse)
      // console.log("🚀 ~ decryptedResponse:", decryptedResponse)
      // console.log("🚀 ~ finalResponse:", finalResponse)
      return finalResponse?.data
    } catch (error) {
      
    }
    // console.log("after",response);

    // return response.userInfo;
  } catch (error) {
    throw error;
  }
});


export const storeLogoutToken = async (params) => {
  const req = `${BASE_URL}/auth/storeLogoutToken`;
  let req_body = {
    body: params,
  };
  const encryptedBodyRes = await encryptPayload("", req_body, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
       "user-id" : params?.userId
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    return await encryptPayload(req, options, false, true, true);
  } catch (err) {
    console.error(err);
  }
};

export const checkTokenExists = async (params) => {
  const req = `${BASE_URL}/auth/checkTokenExists`;
  let req_body = {
    body: params,
  };
  const encryptedBodyRes = await encryptPayload("", req_body, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    let response = await encryptPayload(req, options, false, true, true);
    return response;
  } catch (err) {
    console.error(err);
  }
};
